<template>
    <table class="table table-striped additions-table">
        <thead>
        <tr>
            <th colspan="3">{{trans.attendance.extra_shifts}}</th>
        </tr>
        </thead>
        <tbody>
        <tr
                v-for="(day) in days"
                v-bind:key="day.date"
        >
            <template
                    v-if="day.dailyPersonalBonus"
            >
                <td>{{ day.date | date('DD.MM.YYYY') }}</td>
                <td>{{ day.workDay.intervals_sum_number }}&nbsp;h</td>
                <td class="text-right" style="white-space: nowrap;">
                    <span :id="'popover-hidden-shifts-'+day.workDay.id"><i class="fal fa-info-circle text-info"></i>&nbsp;{{ day.dailyPersonalBonus.toFixed(2) }}&nbsp;{{ restaurantCurrency }}</span>
                    <b-popover :target="'popover-hidden-shifts-'+day.workDay.id" triggers="hover" placement="bottom">
                        <div><b>{{ trans.attendance.statistics.label_calculation }}:</b></div>
                        <div>
                            {{ trans.attendance.statistics.label_base }} ({{ Math.round(day.hourlyRate*100)/100 }}{{ restaurantCurrency }}/h x {{ day.workDay.intervals_sum_number }}h):
                            <b>{{ (day.hourlyRate * day.workDay.intervals_sum_number).toFixed(2) }}&nbsp;{{ restaurantCurrency }}</b>
                        </div>
                        <div v-if="settings.mealVoucherClaim == 1 && day.mealVouchersSum">
                            {{ trans.attendance.statistics.meal_vouchers }}:
                            <b>{{ Math.round(day.mealVouchersSum*100)/100 }}&nbsp;{{ restaurantCurrency }}</b>
                        </div>
                        <div v-if="settings.allowSalaryAdditionWeekend == 1 && day.workDay.is_saturday">
                            {{ trans.attendance.statistics.number_of_saturdays_hours }} (<span v-html="day.hiddenShiftLabels.saturday"></span>):
                            <b>{{ (day.hiddenShiftCalculations.saturday).toFixed(2) }}&nbsp;{{ restaurantCurrency }}</b>
                        </div>
                        <div v-if="settings.allowSalaryAdditionWeekend == 1 && day.workDay.is_sunday">
                            {{ trans.attendance.statistics.number_of_sundays_hours }} (<span v-html="day.hiddenShiftLabels.sunday"></span>):
                            <b>{{ (day.hiddenShiftCalculations.sunday).toFixed(2) }}&nbsp;{{ restaurantCurrency }}</b>
                        </div>
                        <div v-if="settings.allowOffDayWorkedHours == 1 && day.workDay.is_off_day">
                            {{ trans.attendance.statistics.number_of_off_days_hours }} (<span v-html="day.hiddenShiftLabels.offday"></span>):
                            <b>{{ (day.hiddenShiftCalculations.offday).toFixed(2) }}&nbsp;{{ restaurantCurrency }}</b>
                        </div>
                        <div v-if="day.workDay.number_of_night_shifts_hours > 0">
                            {{ trans.attendance.statistics.number_of_night_shifts_hours }} (<span v-html="day.hiddenShiftLabels.nightShift"></span>):
                            <b>{{ (day.hiddenShiftCalculations.nightShift).toFixed(2) }}&nbsp;{{ restaurantCurrency }}</b>
                        </div>
                    </b-popover>
                </td>
            </template>
        </tr>

        <tr>
            <td style="width: 50%"><b>{{trans.attendance.extra_shifts_together }}:</b></td>
            <td><b>{{ (attendance.sum_of_hidden_hours ? attendance.sum_of_hidden_hours : 0) }}&nbsp;h</b></td>
            <td class="text-right"><b>{{  attendance.sum_of_daily_personal_bonuses ? attendance.sum_of_daily_personal_bonuses.toFixed(2) : 0}}&nbsp;{{ restaurantCurrency }}</b></td>
        </tr>

        </tbody>
    </table>
</template>

<script>
    export default {
        name: 'extra-shifts',
        data: function() {
            return {}
        },
        props: {
            'days': {
                type: Array
            },
            'trans': {
                type: Object
            },
            'restaurantCurrency': {
                type: String
            },
            'settings': {
                type: Object
            },
            'attendance': {
                type: Object
            },
            'dateFilter': {
                type: Function
            }
        },
        created() {},
        methods: {},
        filters: {
            date: function date(date) {
                var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

                var date = (0, moment)(date);
                return date.isValid() ? date.format(format) : "";
            },
            datetime: function datetime(_datetime) {
                var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

                var date = (0, moment)(_datetime);
                return date.isValid() ? date.format(format) : "";
            },
            time: function time(_time) {
                var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'HH:mm:ss';

                var date = (0, moment)('2000-01-01 ' + _time);
                return date.isValid() ? date.format(format) : "";
            },
            floatToTime: function floatToTime(number) {
                var date = new Date(number * 3600 /* sec per hr */
                    * 1000 /* msec per sec */);
                return ('0' + date.getUTCHours()  ).slice(-2) + ':' +
                    ('0' + date.getUTCMinutes()).slice(-2);
            }
        },
    }
</script>


<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/show/ExtraShifts.vue